import styled from 'styled-components'
import { black, textMuted } from '@/theme/colors'
import { text } from '@/theme/typography'
import { Button } from '@components/Button'

/** Heads the calendar: a line of its own even where the calendar and the legend sit side by side. */
export const SummaryRow = styled.div`
	flex: none;
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 12px;
`

export const SummaryRange = styled.div`
	${text.label}
	color: ${black};
`

export const SummaryDetail = styled.div`
	${text.caption}
	color: ${textMuted};
	margin-top: 2px;
`

export const EditDestinationsButton = styled(Button).attrs({ variant: 'icon' as const })`
	flex: none;
`
